const exclude = [
  '1f377.svg',
  '1f378.svg',
  '1f379.svg',
  '1f37b.svg',
  '1f37e.svg',
  '1f47e.svg',
  '1f4a9.svg',
  '1f942.svg',
  '1f943.svg',
  '1fa72.svg'
]

const emojis = require.context('~/static/emoji', false, /\.[jepnsvg]{3}$/).keys()
const businessEmojis = require.context('~/static/emoji-business', false, /\.[jepnsvg]{3}$/).keys()

const mapEmojis = (emojis, path = 'emoji') => {
  return emojis
    .filter(emoji => !exclude.map(excluded => './' + excluded).includes(emoji))
    .map(key => '/' + path + key.replace(/^\./, ''))
}

const getEmojis = () => {
  return mapEmojis(emojis)
}

const getBusinessEmojis = () => {
  return mapEmojis(businessEmojis, 'emoji-business')
}

export const emoji = getEmojis()
export const businessEmoji = getBusinessEmojis()

export const avatarStyles = {
  FRIENDLY: null,
  BUSINESS: 'business',
  TEXT: 'text',
  NONE: 'none'
}
